import React from "react";

import { Switch, useRouteMatch, Redirect } from "react-router-dom";

import MinewDevice from "./Device";
import MinewDevices from "./Devices";

import Route from "../../components/Route";

const MinewsRouter = React.memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route.Private exact path={path}>
        <MinewDevices />
      </Route.Private>
      <Route.Role exact path={`${path}/new`} roles={["ADMIN"]} redirect={path}>
        <MinewDevice />
      </Route.Role>
      <Route.Private path={`${path}/:minewId`}>
        <MinewDevice />
      </Route.Private>
      <Redirect to={path} />
    </Switch>
  );
});

export default MinewsRouter;
